<template>
  <v-dialog v-model="showCancelSubscriptionDialog" max-width="1200">
    <v-card v-if="showCancelSubscriptionDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline">{{ $t('texts.cancelSubscription') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="closeDialog()">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="!form.has_active_additional_companies">
        <p v-html="$t('texts.subscriptionTerminateDialog.intro')"></p>
        <ul>
          <li>{{ form.company_name }}</li>
        </ul>
        <br>
        <p>
          <i18n path="texts.subscriptionTerminateDialog.info">
            <span>{{ form.next_possible_cancellation_date | formatDateShort }}</span>
          </i18n>
        </p>
        <div v-html="$t('texts.subscriptionTerminateDialog.options')"></div>
      </v-card-text>
      <v-card-text v-else>
        <p>
          {{ $t('texts.subscriptionTerminateDialog.hasActiveAdditionalCompanies') }}
        </p>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          class="white--text"
          color="red"
          @click="validateBeforeSubmit()"
          :disabled="cancelSubscriptionPending || form.has_active_additional_companies"
          :loading="cancelSubscriptionPending"
        >
          {{ $t('texts.cancelSubscription') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const {
  mapState: mapSubscriptionState,
  mapActions: mapSubscriptionActions,
} = createNamespacedHelpers('subscription');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'CancelSubscriptionDialog',
  data() {
    return {
      showCancelSubscriptionDialog: false,
      form: {
        subscription_id: null,
        stripe_plan_id: null,
        company_id: null,
        company_name: '',
        additional_company_id: null,
        next_possible_cancellation_date: '',
        has_active_additional_companies: null,
        type: '',
      },
    };
  },
  mounted() {
    this.$eventBus.$on('show-cancel-subscription-dialog', (payload) => {
      this.reset();
      Object.assign(this.form, payload);
      this.showCancelSubscriptionDialog = true;
    });
  },
  computed: {
    ...mapSubscriptionState([
      'cancelSubscriptionPending',
    ]),
  },
  methods: {
    ...mapSubscriptionActions([
      'cancelSubscription',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        subscription_id: null,
        company_id: null,
        company_name: '',
        additional_company_id: null,
        next_possible_cancellation_date: '',
        hasActiveAdditionalCompanies: null,
        type: '',
      };
      this.subscription = {};
      this.$validator.reset();
    },
    closeDialog() {
      this.showCancelSubscriptionDialog = false;
      this.reset();
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.cancelSubscription(this.form).then(() => {
            this.showCancelSubscriptionDialog = false;
            this.reset();
          });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
